import React from 'react';
import { Flag } from 'lucide-react';
import { AdminStatusPill } from '../../ui';
import './report-moderation.css';

// Nhãn lý do báo cáo: viên đỏ nhạt kèm icon cờ, theo thiết kế mới.
export const ReasonPill = ({ children }: { children: React.ReactNode }) => (
  <AdminStatusPill tone="danger" icon={<Flag size={12} aria-hidden="true" />}>
    {children}
  </AdminStatusPill>
);

// Hàng nhãn : giá trị (nhãn xám 112px bên trái).
export const ReportKv = ({ children, loose }: { children: React.ReactNode; loose?: boolean }) => (
  <dl className={`adm-report-kv${loose ? ' adm-report-kv--loose' : ''}`}>{children}</dl>
);

export const KvRow = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <>
    <dt>{label}</dt>
    <dd>{children}</dd>
  </>
);
